export enum MeridianKeyDatesType {
    S_LEAD = 'sLead',
    S_OPENED = 'sOpened',
    S_PREQUAL = 'sPreQual',
    S_SUBMIT = 'sSubmit',
    S_PREPROCESSING = 'sPreProcessing',
    S_PROCESSING = 'sProcessing',
    S_DOCUMENTCHECK = 'sDocumentCheck',
    S_DOCUMENTCHECKFAILED = 'sDocumentCheckFailed',
    S_LOANSUBMITTED = 'sLoanSubmitted',
    S_PREUNDERWRITING = 'sPreUnderwriting',
    S_UNDERWRITING = 'sUnderwriting',
    S_PREAPPROV = 'sPreApprov',
    S_APPROV = 'sApprov',
    S_CONDITIONREVIEW = 'sConditionReview',
    S_FINALUNDERWRITING = 'sFinalUnderwriting',
    S_PREDOCQC = 'sPreDocQC',
    S_CLEARTOCLOSE = 'sClearToClose',
    S_DOCSORDERED = 'sDocsOrdered',
    S_DOCSDRAWN = 'sDocsDrawn',
    S_DOCS = 'sDocs',
    S_DOCSBACK = 'sDocsBack',
    S_FUNDINGCONDITIONS = 'sFundingConditions',
    S_FUND = 'sFund',
    S_RECORDED = 'sRecorded',
    S_FINALDOCS = 'sFinalDocs',
    S_CLOSED = 'sClosed',
    S_SUBMITTEDFORPURCHASEREVIEW = 'sSubmittedForPurchaseReview',
    S_INPURCHASEREVIEW = 'sInPurchaseReview',
    S_PREPURCHASECONDITIONS = 'sPrePurchaseConditions',
    S_SUBMITTEDFORFINALPURCHASE = 'sSubmittedForFinalPurchase',
    S_INFINALPURCHASEREVIEW = 'sInFinalPurchaseReview',
    S_CLEARTOPURCHASE = 'sClearToPurchase',
    S_PURCHASED = 'sPurchased',
    S_READYFORSALE = 'sReadyForSale',
    S_SHIPPEDTOINVESTOR = 'sShippedToInvestor',
    S_SUSPENDEDBYINVESTOR = 'sSuspendedByInvestor',
    S_ADDITIONALCONDSENT = 'sAdditionalCondSent',
    S_LPURCHASE = 'sLPurchase',
    S_COUNTEROFFER = 'sCounterOffer',
    S_ONHOLD = 'sOnHold',
    S_CANCELED = 'sCanceled',
    S_SUSPENDED = 'sSuspended',
    S_REJECT = 'sReject',
    S_WITHDRAWN = 'sWithdrawn',
    S_ARCHIVED = 'sArchived',
    S_QCCOMP = 'sQCComp',
    S_INITAL_LOAN_ESTIMATE_ISSUED = 'sInitialLoanEstimateIssued',
    S_INITAL_LOAN_ESTIMATE_SIGNED = 'sInitialLoanEstimateSigned',
    S_LAST_DISCLOSED_LOAN_ESTIMATE_ISSUED = 'sLastDisclosedLoanEstimateIssued',
    S_LAST_DISCLOSED_LOAN_ESTIMATE_SIGNED = 'sLastDisclosedLoanEstimateSigned',
    S_INITIAL_CLOSING_DISCLOSURE_ISSUED = 'sInitialClosingDisclosureIssued',
    S_INITIAL_CLOSING_DISCLOSURE_SIGNED = 'sInitialClosingDisclosureSigned',
    S_LAST_CLOSING_DISCLOSURE_BEFORE_CONSUMMATION_ISSUED = 'sLastClosingDisclosureBeforeConsummationIssued',
    S_LAST_CLOSING_DISCLOSURE_BEFORE_CONSUMMATION_SIGNED = 'sLastClosingDisclosureBeforeConsummationSigned',
    S_RLCKDEXPIRED = 'sRLckdExpired',
}
